/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  enableProdMode,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  importProvidersFrom,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
  withInMemoryScrolling,
} from '@angular/router';
import { routes } from './app/app-routing.module';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgbModule, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { AppDatepickerI18n } from './app/app.component';
import { provideStore } from '@ngrx/store';
import { metaReducers, reducers } from './app/shared/store-manager/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { JwtInterceptor } from './app/_helper/jwt.interceptor';
import { ErrorHandlingInterceptor } from './app/shared/error-handling/error-handling.interceptor';
import { AuthAmplifyService } from './app/shared/service/auth-amplify.service';
import { LanguageService } from './app/shared/service/language.service';
import { RandomNumberGeneratorService } from './app/shared/service/random-number-generator.service';
import { TranslationService } from './app/shared/service/translation.service';
import { firstValueFrom, tap } from 'rxjs';


export function loadFeatureFlagsFactory(
  translationService: TranslationService,
): () => Promise<any> {
  return async () => {
    const [featureFlags, supportedLanguages] = await Promise.all([
      firstValueFrom(
        translationService.getAllFeatureFlags().pipe(
          tap((featureFlags: any) => {
            translationService.featureFlags = featureFlags;
          })
        )
      ),
      firstValueFrom(
        translationService.getAllSupportedLanguages().pipe(
          tap((supportedLanguages: any) => {
            translationService.supportedLanguagesForDisplay = supportedLanguages;
          })
        )
      ),
    ]);
    return [featureFlags, supportedLanguages];
  };
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      NgbModule,
      TranslateModule.forRoot(),
      GoogleMapsModule,
    ),
    { provide: NgbDatepickerI18n, useClass: AppDatepickerI18n },
    provideStore(reducers, { metaReducers }),
    LanguageService,
    TranslateService,
    AuthAmplifyService,
    RandomNumberGeneratorService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadFeatureFlagsFactory,
      deps: [TranslationService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (service: AuthAmplifyService) => () => service.init(),
      deps: [AuthAmplifyService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlingInterceptor,
      multi: true,
    },
  ],
}).catch(err => console.error(err));
